import React, { FC, useEffect, useMemo, useState } from "react"
import {
    useGetOrderNoteByTypeAndIdQuery,
    useLazyGetProductTaskListQuery,
    useLazyGetQCLogicResultListQuery,
} from "../../productsApi";
import {
    useCheckHoaOrderResultValidMutation,
    useCheckIsPdfExistQuery,
    useCheckUserIsManagerQuery,
    useGenerateHoaPdfServiceMutation,
    useGetHoaOrderResultByOrderIdQuery,
    useGetOrderByOrderIdAndTypeQuery,
    useIsPdfExistMutation,
    useLazyCheckPrimaryCollectorExistActionQuery,
    useLazyGetSimilarHoaAccountInfoQuery,
    useSaveHoaOrderResultMutation, useUpdateProductStatusMutation
} from "../../ordersApi";
import { useParams } from "react-router-dom";
import LeftBar from "../Common/LeftNavBar/LeftBar";
import { fetchPdf, returnNestedKeyValues, showToast } from "../../../../helpers/utils/Utils";
import {
    getUserFriendlyTaxDataSource,
    isDuplicateAccountExist,
    lowerCaseAllWordsExceptFirstLetters,
    updateTotalBalance,
    upperCaseFirstLetter
} from "../../../../helpers/utils/OrderDetailUtils";
import { RequestedInfoSection } from "../Sections/RequestedInfoSection";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import InputField from "../../../../components/common/form/InputField";
import { CommentNoteSection } from "../Sections/CommentNoteSection";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { PropertyInfoSection } from "./PropertyInfoSection";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import TopSection from "../Common/TopSection/TopSection";
import { useUtilDataQuery } from "../../../profile/profileApi";
import EditorAddEditNoteForm from "../../modal/EditorAddEditNoteForm";
import _, { isArray } from "lodash";
import {
    checkProperties,
    formatPhone,
    getUniqueFeeListAndNote,
    PopulateHoaInfo,
    removeDuplicateAndNegativeItems,
    setTaskList
} from "../TaxCertificate/Utils";
import {
    useLazyGetAllCountyByStateAbbrQuery,
    useLazyGetAllCountyByStateIdQuery,
    useLazyGetCountyByIdQuery
} from "../../../data/counties/countiesApi";
import { tgxApi } from "../../../../app/tgxApi";
import { useDispatch } from "react-redux";
import { useLazyGetSubdivisionByNameAndCountyQuery } from "../../../data/subDivision/subDivisionApi";
import HoaInfoSection from "./HoaInfoSection";
import { FeeListSection } from "./FeeListSection";
import PdfDeliveryConfirmationModal from "../Common/Modals/PdfDeliveryConfirmationModal";
import Preloader from "../../../../components/common/Preloader";
import LockConfirmationPopUp from "../../modal/LockConfirmationPopUp";
import GenerateActivePdf from "../Common/Modals/GenerateActivePdf";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";


const HoaDetailTabSection: FC = () => {

    let { orderId } = useParams();

    const [accounts, setAccounts] = useState<any>([]);
    const [showAccount, setShowAccount] = useState<any>(1);
    const [certificate, setCertificate] = useState<any>({
        "accounts": accounts, "propertyIds": []
    });
    const [removedAccountIds, setRemovedAccountIds] = useState<any>([]);
    const [updatedAccountIndexList, setUpdatedAccountIndexList] = useState<any>([]);
    const [isSavedResult, setIsSavedResult] = useState(false);
    const [orderResultModifiedDate, setOrderResultModifiedDate] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [assignTo, setAssignTo] = useState("");
    const [productStatus, setProductStatus] = useState("");
    const [isAccountNoteDeleted, setIsAccountNoteDeleted] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [showUpdateCommentModal, setShowUpdateCommentModal] = useState(false);
    const [showAddCommentModal, setShowAddCommentModal] = useState(false);
    const [noteIndex, setNoteIndex] = useState(0);
    const [curProduct, setCurProduct] = useState({});
    const [productId, setProductId] = useState("");
    const [assignedTeam, setAssignedTeam] = useState(null);
    const [showTeamListModal, setShowTeamListModal] = useState(false);
    const [addedNewAccount, setAddedNewAccount] = useState(false);
    const [addAccountSelectedProperty, setAddAccountSelectedProperty] = useState(null);
    const [customerOrderNumber, setCustomerOrderNumber] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [tenant, setTenant] = useState("");
    const [propertyHaveResult, setPropertyHaveResult] = useState([]);
    const [requiresQc, setRequiresQc] = useState(false);
    const [orderStatus, setOrderStatus] = useState("");
    const [isPropertyResultAvailable, setIsPropertyResultAvailable] = useState(false);
    const [deliveryEmail, setDeliveryEmail] = useState([]);
    const [isSendNotification, setIsSendNotification] = useState(false);
    const [showDeliveryConfirmation, setShowDeliveryConfirmation] = useState(false);
    const [showTeamManagerModal, setShowTeamManagerModal] = useState(false);
    const [showDeleteAccountConfirmation, setShowDeleteAccountConfirmation] = useState(false);
    const [activeTaskConfirmation, setActiveTaskConfirmation] = useState(false);
    const [lockEditorPopUp, setLockEditorPopUp] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    }
    const [isValidDataForPdfGenerate, setIsValidDataForPdfGenerate] = useState(false);
    const [showAccountCloneModal, setShowAccountCloneModal] = useState(false);
    const [tempList, setTempList] = useState<any[]>([]);
    const [selectedCloneAccountList, setSelectedCloneAccountList] = useState([]);
    const [isPdfExist, setIsPdfExist] = useState(false);
    const [isFetchSimilarAccountList, setIsFetchSimilarAccountList] = useState(false);
    const [similarAccountList, setSimilarAccountList] = useState<any[]>([]);
    const [primaryCollector, setPrimaryCollector] = useState(null);
    const [reset, setReset] = useState(false);
    const [countyIdForNewAcct, setCountyIdForNewAcct] = useState(false);
    const [checkBox, setCheckBox] = useState(false);
    const [warningMsg, setWarningMsg] = useState("");
    const [warningModal, setWarningModal] = useState(false);
    const [disable, setDisable] = useState(false);
    const [toggleAccountSection, setToggleAccountSection] = useState(true);
    const [customerNoteList, setCustomerNoteList] = useState([]);
    const [certNoteList, setCertNoteList] = useState([]);
    const [productType, setProductType] = useState("");
    const [vendorTaskList, setVendorTaskList] = useState([]);
    const [editable, setEditable] = useState(true);
    const [qcResultList, setQcResultList] = useState([]);
    const [unAcknowledged, setUnAcknowledged] = useState([]);
    const [isEmptyState, setIsEmptyState] = useState(false);
    const [isEmptyCounty, setIsEmptyCounty] = useState(false);
    const [docList, setDocList] = useState([]);

    const dispatch = useDispatch();
    const orderQuery = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: 'Hoa' });
    const orderResultData = useGetHoaOrderResultByOrderIdQuery(orderId)
    const clonedOrderResultData = _.cloneDeep(orderResultData);
    const { data: notesData } = useGetOrderNoteByTypeAndIdQuery({
        orderId,
        noteTypes: ["HOA", "CUSTOMER"],
    });
    const isUserManager = useCheckUserIsManagerQuery(orderId)
    const { data: stateData } = useGetAllStatesQuery("");
    const [checkPdfExist, { data: pdfExistData }] = useIsPdfExistMutation();
    const [checkHoaOrderResultValid] = useCheckHoaOrderResultValidMutation();
    const [getProductTaskList, { data: taskList }] = useLazyGetProductTaskListQuery();
    const { data: utilData } = useUtilDataQuery("");
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const [getQcLogicResultDataApi, getQcLogicResultDataResponse] = useLazyGetQCLogicResultListQuery();
    const [triggerCheckPrimaryCollector] = useLazyCheckPrimaryCollectorExistActionQuery();
    const [getCountyByIdApi, getCountyByIdResponse] = useLazyGetCountyByIdQuery();
    const [getCountyByStateIdApi, getCountyByStateIdResponse] = useLazyGetAllCountyByStateIdQuery();
    const [getSubdivisionByNameAndCountyApi, getSubdivisionByNameAndCountyResponse] = useLazyGetSubdivisionByNameAndCountyQuery();
    const [saveHoaOrderResult, saveOrderResultApi] = useSaveHoaOrderResultMutation();
    const [generateHoaPdf, generateHoaPdfApi] = useGenerateHoaPdfServiceMutation();
    const [markAsCompleted, markAsCompletedApi] = useUpdateProductStatusMutation();
    const [similarHoaAccountListApi, similarHoaAccountListResponse] = useLazyGetSimilarHoaAccountInfoQuery();

    let isHoaContact = window.location.href.indexOf("hoaContactEditor") > -1;
    let customFilter = {
        'orderId': orderId,
        'orderFileType': [isHoaContact ? "HOAContact" : "HOAFull"],
        'type': 'New'
    }

    useEffect(() => {
        if (orderStatus !== '' && (orderStatus === 'AWAITING_LOCATE' || orderStatus === 'NEW') && !isPropertyResultAvailable) {
            setLockEditorPopUp(true);
        }
    }, [orderStatus]);

    useEffect(() => {
        if (notesData && notesData.error === undefined) {
            setCertNoteList(notesData.filter((el: any) => el.noteType === "HOA"));
            setCustomerNoteList(notesData.filter((el: any) => el.noteType === "CUSTOMER"));
        }
    }, [notesData]);

    useEffect(() => {
        // getContactEmail({ email: null, isHoa: true });

        let isHoaContact = window.location.href.indexOf("hoaContactEditor") > -1;
        if (isHoaContact) {
            setProductType("HOA_CONTACT");
        } else {
            setProductType("HOA_FULL");
        }

        const customFilter = {
            orderId,
            orderFileType: [isHoaContact ? "HOAContact" : "HOAFull"],
            type: "New",
        };

        checkPdfExist(customFilter);

    }, []);

    const handleCheckValid = async (obj: any, orderId: string) => {
        try {
            const result = await checkHoaOrderResultValid({ obj, orderId }).unwrap();
            setIsValidDataForPdfGenerate(result); // same as old flow
        } catch (error) {
            console.error('Error validating HOA Order Result:', error);
        }
    };

    useEffect(() => {
        if (orderResultData?.data && orderId) {

            if (orderResultData.data.length > 0) {
                handleCheckValid(clonedOrderResultData.data, orderId);
                const propertyIds: string[] = [];

                const updatedCertificate = {
                    ...certificate,
                    accounts: orderResultData.data,
                };
                setCertificate(updatedCertificate);

                orderResultData.data.forEach((account: any) => {
                    accountInfo(account, propertyIds);
                });

                setOrderResultModifiedDate(orderResultData.data[0]?.modifiedDate || orderResultModifiedDate);
                setShowAccount(0);
                setIsSavedResult(true);
                setShowForm(true);
            }
            setIsFetchSimilarAccountList(true);
        }
    }, [orderResultData, orderId]);

    useEffect(() => {
        if (certificate.accounts && certificate.accounts.length > 0 && showAccount !== undefined) {
            const currentAccountNumber = certificate.accounts[showAccount]?.accountNumber;

            setSimilarAccountList(
                tempList.length > 0
                    ? tempList.filter((el: any) => el.accountNumber === currentAccountNumber)
                    : []
            );
        } else {
            setSimilarAccountList([]);
        }

    }, [tempList, certificate.accounts, showAccount]);

    useEffect(() => {
        if (selectedCloneAccountList.length > 0) {
            const propertyIds: any[] = [];
            const updatedAccounts = [...certificate.accounts]; // Clone the existing accounts
            const updatedIndices: number[] = [];
            const removedIds: string[] = [...removedAccountIds]; // Clone to update separately

            selectedCloneAccountList.forEach((el: any) => {
                if (!el || !el.certificateAccountDTO) {
                    console.error('Invalid account data:', el);
                    return;
                }
                const clonedDTO = {
                    ...el.certificateAccountDTO,
                    id: null,
                    orderPropertyId: null
                };
                const index = updatedAccounts.findIndex((pDay) => isDuplicateAccountExist(clonedDTO, pDay));

                if (index > -1) {
                    if (updatedAccounts[index].id != null && updatedAccounts[index].id !== "") {
                        removedIds.push(updatedAccounts[index].id);
                    }
                    updatedAccounts[index] = clonedDTO;
                    updatedIndices.push(index);
                } else {
                    updatedAccounts.push(clonedDTO);
                    updatedIndices.push(updatedAccounts.length - 1);

                }

            });
            updatedAccounts.forEach((account) => {
                accountInfo(account, propertyIds);
            });

            setCertificate((prev: any) => ({
                ...prev,
                accounts: updatedAccounts,
            }));

            setShowAccount(updatedAccounts.length - 1);
            showToast("Successfully cloned all accounts!", "success");
            setUpdatedAccountIndexList(updatedIndices);
            setIsSavedResult(false);
            setShowAccountCloneModal(false);

            // Update removedAccountIds list if needed
            removedAccountIds.length = 0;
            removedAccountIds.push(...removedIds);
        }

        setRemovedAccountIds(removedAccountIds);

    }, [selectedCloneAccountList]);

    useEffect(() => {
        if (similarHoaAccountListResponse?.data) {
            setTempList([...similarHoaAccountListResponse.data]);
        }
    }, [similarHoaAccountListResponse]);

    useEffect(() => {
        if (pdfExistData !== undefined) {
            setIsPdfExist(pdfExistData);
        }

    }, [pdfExistData]);


    useEffect(() => {
        if (!isFetchSimilarAccountList) {
            return;
        }

        let propertyIds: any = [];
        certificate.accounts.filter((el: any) => {
            if (el.original) {
                if (el.accountNumber) {
                    propertyIds.push(el.accountNumber);
                }
            }
        });
        if (propertyIds.length > 0) {
            similarHoaAccountListApi({ orderId: orderId, propertyIds });
        }
        setIsFetchSimilarAccountList(false);
    }, [isFetchSimilarAccountList]);

    useEffect(() => {

        setSimilarAccountList(tempList.length > 0 ? tempList.filter((el: any) => el.propertyId === certificate.accounts[showAccount]?.propertyId) : []);

    }, [tempList]);


    useEffect(() => {
        if (taskList?.data !== undefined) {
            setTaskList(taskList.data, setVendorTaskList, orderQuery?.data?.properties);
        }
    }, [taskList]);

    async function handleCheckPrimaryCollector(
        county: string,
        state: string,
        setPrimaryCollector: (value: any) => void,
        setModuleAvailableForCounty?: (value: boolean) => void,
        setPrimaryCollectorId?: (id: number | undefined) => void,
    ) {

        try {
            const resultData = await triggerCheckPrimaryCollector({ county: county, stateAbbreviation: state }).unwrap();

            if (setModuleAvailableForCounty) {
                setModuleAvailableForCounty(
                    resultData != null &&
                    resultData.scraperModuleId !== null &&
                    resultData.scraperModuleId !== ""
                );
            }

            if (setPrimaryCollectorId) {
                setPrimaryCollectorId(resultData != null ? resultData.id : undefined);
            }

            setPrimaryCollector(resultData);
        } catch (error) {
            console.error("Failed to check primary collector:", error);
        }
    }

    useEffect(() => {

        if (orderQuery?.data && orderResultData?.data && orderResultData?.data?.length === 0) {
            const newAccounts = orderQuery?.data?.properties
                .filter((property: any) => !property?.propertyResult?.skipAutomation)
                .map((property: any, index: any) => {
                    const propertyResult = property?.propertyResult;
                    let taxId = propertyResult === null || propertyResult.taxId === null || propertyResult === '' ? '#' + (index + 1) : propertyResult.taxId;

                    return {
                        fees: [{
                            type: null,
                            amount: null,
                            currentMonth: null,
                            nextMonth: null,
                            periodStart: null,
                            periodEnd: null,
                            frequency: null,
                            note: null,
                            paid: null,
                            associationFee: false,
                        }],
                        managementCompany: {
                            name: "",
                            contactName: "",
                            website: "",
                            address: {
                                mailingAddress: "",
                                zipCode: "",
                                city: "",
                                state: "",
                            },
                            phone: "",
                            email: "",
                            managementCompanyId: "",
                        },
                        notes: [],
                        productType: productType,
                        associationName: "",
                        orderPropertyId: property.id,
                        subdivisionId: "",
                        propertySubdivision: propertyResult === null ? '' : propertyResult.subdivisionName,
                        stateId: orderQuery.data.stateId,
                        countyId: orderQuery.data.countyId,
                        zipCode: propertyResult === null ? null : (propertyResult.parsedAddress != null ? propertyResult.parsedAddress.postalCode : null),
                        subdivisionCode: "",
                        sellers: orderQuery.data.sellerName,
                        buyers: orderQuery.data.buyerName,
                        situsAddress: propertyResult === null ? property.addressLine1 : propertyResult.address,
                        legalDescription: propertyResult === null ? property.legalDescription : propertyResult.legalDescription,
                        accountNumber: taxId,
                        acreage: "",
                        orderId: orderId,
                        original: true,
                        addAsAlias: false,
                        taxDataSource: "EDITOR",
                        total: 0.00
                    };
                });

            const newPropertyIds = newAccounts?.map((account: any) => ({
                id: account.accountNumber,
                visibility: true,
            }));


            setCertificate((prev: any) => (
                {
                    accounts: newAccounts,
                    propertyIds: newPropertyIds,
                }));

            // const newIndexes = newAccounts?.map((_: any, idx: any) =>  idx);
            // setUpdatedAccountIndexList((prev: any) => [...prev, ...newIndexes]);
            setIsSavedResult(false);
            setShowAccount(0);
            setShowForm(true);
        }
    }, [orderQuery, orderResultData]);

    useEffect(() => {
        if (!orderQuery.data || orderQuery.data.error !== undefined) return;

        getAllCountyByStateAbbrApi(orderQuery.data.state);
        setCustomerOrderNumber(orderQuery.data.customerOrderNumber);
        setCustomerId(orderQuery.data.customerDTO.id);
        setTenant(orderQuery.data.tenant);

        const hoaProduct = orderQuery.data.products.find((product: any) => product.type.includes("HOA_"));
        if (hoaProduct) {
            setProductStatus(hoaProduct.productStatus);
            setCurProduct(hoaProduct);
            getQcLogicResultDataApi(hoaProduct.id);
            getProductTaskList(hoaProduct.id);
            setEditable(orderQuery.data.active && hoaProduct.assignedTo === utilData.userName);
            setAssignTo(hoaProduct.assignedTo);
            setProductId(hoaProduct.id);
            setRequiresQc(hoaProduct.requiresQc);
            setOrderStatus(orderQuery.data.orderStatus);
        }

        const propertiesWithResult = orderQuery?.data?.properties?.filter((property: any) => property.propertyResult !== null);
        setPropertyHaveResult(propertiesWithResult);

        if (orderQuery?.data?.properties?.length > 0) {
            const firstProperty = orderQuery.data.properties[0];
            const parsedAddress = firstProperty.propertyResult?.parsedAddress;

            const county = parsedAddress?.county || orderQuery.data.county;
            const state = parsedAddress?.state || orderQuery.data.state;

            handleCheckPrimaryCollector(
                county,
                state,
                setPrimaryCollector,
                undefined,
                undefined
            );

            setIsPropertyResultAvailable(
                !!firstProperty.propertyResult && firstProperty.propertyResult !== ''
            );
        }
    }, [orderQuery, utilData]);


    useMemo(() => {
        if (showAccount === null) return;

        if (certificate.accounts.length > 0) {
            const currentAccount = certificate.accounts[showAccount];
            const countyId = currentAccount.countyId;

            if (countyId) {
                getCountyByIdApi(countyId);
            }

            setSimilarAccountList(
                tempList.length > 0
                    ? tempList.filter((el) =>
                        el.accountNumber.replace('-CLONE', '') === currentAccount.accountNumber
                    )
                    : []
            );
        }
    }, [showAccount]);

    useMemo(() => {
        if (
            showAccount !== null &&
            orderResultData.data &&
            getCountyByIdResponse?.data &&
            getCountyByIdResponse.data.id === certificate.accounts[showAccount]?.countyId
        ) {
            const stateId = certificate.accounts[showAccount].stateId;

            if (stateId) {
                getCountyByStateIdApi(stateId);
            }
        }
    }, [getCountyByIdResponse, showAccount, orderResultData]);

    useMemo(() => {
        if (getQcLogicResultDataResponse.data) {
            setQcResultList(getQcLogicResultDataResponse.data);
            setUnAcknowledged(JSON.parse(JSON.stringify(getQcLogicResultDataResponse.data)).filter((el: any) => el.result && (el.acknowledgedBy == null || el.acknowledgedBy === "")));
        }
    }, [getQcLogicResultDataResponse]);


    useEffect(() => {
        if (!reset) return;

        if (!certificate?.accounts?.[showAccount]) return;

        const account = { ...certificate.accounts[showAccount] };

        // Reset subdivisionId
        account.subdivisionId = "";

        // Filter fees
        account.fees = account.fees?.filter((v: any) => v.associationFee !== true) ?? [];

        // Ensure at least one default fee exists
        if (account.fees.length === 0) {
            account.fees.push({
                type: null,
                amount: '',
                currentMonth: '',
                nextMonth: '',
                periodStart: '',
                periodEnd: '',
                frequency: '',
                note: '',
                paid: '',
                associationFee: false,
            });
        }

        updateTotalBalance(account, account.fees);

        // Filter notes
        account.notes = account.notes?.filter((v: any) => v.associationNote !== true) ?? [];

        // Clear association and provider info
        account.subdivisionDTO = "";
        account.associationId = "";
        account.associationName = "";
        account.thirdPartyProviderId = "";
        account.thirdPartyProviderName = "";
        account.associationStatus = null;

        // Safely reset management company
        account.managementCompany = {
            ...account.managementCompany,
            name: "",
            managementCompanyId: "",
            contactName: "",
            email: "",
            phone: "",
            website: "",
            address: {
                ...account.managementCompany?.address,
                mailingAddress: "",
                zipCode: "",
                city: "",
                state: ""
            }
        };

        const updatedAccounts = [...certificate.accounts];
        updatedAccounts[showAccount] = account;

        setCertificate({
            ...certificate,
            accounts: updatedAccounts,
        });

        setReset(false);
        setIsSavedResult(false);
    }, [reset]);


    useEffect(() => {
        if (countyIdForNewAcct && getCountyByStateIdResponse.data && getCountyByStateIdResponse?.data[0].state?.id === certificate.accounts[showAccount].stateId) {
            certificate.accounts[showAccount]['countyId'] = getCountyByStateIdResponse.data.find((cur: any) => cur.countyName === orderQuery.data?.properties[0].propertyResult?.parsedAddress?.county)?.id

            setCertificate(certificate);
            setCountyIdForNewAcct(false);
        }
    }, [countyIdForNewAcct, getCountyByStateIdResponse]);

    useEffect(() => {


        if (addedNewAccount && stateData) {
            const stateAbbr = orderQuery.data?.properties?.[0]?.propertyResult?.parsedAddress?.state;
            const countyName = orderQuery.data?.properties?.[0]?.propertyResult?.parsedAddress?.county;

            const matchedState = stateData.find((cur: any) => cur.stateAbbreviation === stateAbbr);
            const matchedCounty = getCountyByStateIdResponse.data?.[0]?.state?.stateAbbreviation === stateAbbr
                ? getCountyByStateIdResponse.data.find((cur: any) => cur.countyName === countyName)
                : undefined;

            const newAccount = {
                fees: [{
                    type: null,
                    amount: null,
                    currentMonth: null,
                    nextMonth: null,
                    periodStart: null,
                    periodEnd: null,
                    frequency: null,
                    note: null,
                    paid: null,
                    associationFee: false
                }],
                managementCompany: {
                    managementCompanyId: "",
                    name: "",
                    address: {
                        mailingAddress: "",
                        zipCode: "",
                        city: "",
                        state: ""
                    },
                    phone: "",
                    email: "",
                    website: ""
                },
                notes: [],
                productType,
                associationName: "",
                associationStatus: null,
                associationId: "",
                thirdPartyProviderId: "",
                thirdPartyProviderName: "",
                propertySubdivision: "",
                stateId: matchedState?.id || "",
                countyId: matchedCounty?.id || "",
                subdivisionDTO: "",
                zipCode: "",
                subdivisionId: "",
                subdivisionCode: "",
                sellers: "",
                buyers: "",
                situsAddress: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.address"),
                legalDescription: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.legalDescription"),
                accountNumber: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.taxId"),
                acreage: "",
                orderId,
                customerOrderNumber,
                original: true,
                addAsAlias: false,
                taxDataSource: "EDITOR",
                total: 0.00
            };

            const updatedAccounts = [...certificate.accounts, newAccount];
            const updatedPropertyIds = [
                ...certificate.propertyIds,
                { id: newAccount.accountNumber, visibility: true }
            ];

            setCertificate((prev: any) => ({
                ...prev,
                accounts: updatedAccounts,
                propertyIds: updatedPropertyIds
            }));

            setIsSavedResult(false);
            setAddedNewAccount(false);
            setShowForm(true);
            setShowAccount(0);

            setUpdatedAccountIndexList((prev: any) => [...prev, updatedAccounts.length - 1]);

            if (!getCountyByStateIdResponse.data || getCountyByStateIdResponse.data[0]?.state?.stateAbbreviation !== stateAbbr) {
                if (matchedState?.id) {
                    getCountyByStateIdApi(matchedState.id);
                }
            }

            setCountyIdForNewAcct(true);
        }
    }, [addedNewAccount]);

    useEffect(() => {
        if (!getSubdivisionByNameAndCountyResponse.data) return;

        const subDivisionObj = getSubdivisionByNameAndCountyResponse.data;
        const associations = getSubdivisionByNameAndCountyResponse.data.associations || [];
        const originalAccounts = [...certificate.accounts];
        const certificateFee = certificate.accounts[showAccount].fees;
        const updatedIndices = [...updatedAccountIndexList];
        const updatedAccounts = [...originalAccounts];
        const updatedPropertyIds = [...certificate.propertyIds];

        updatedIndices.push(showAccount);

        const baseNotes = certificate?.accounts[showAccount]?.notes
            .filter((nl: any) => nl.associationNote !== true)
            .map((nl: any) => ({
                comment: nl.comment,
                associationNote: false,
                redColor: nl.redColor,
                yellowHighlight: nl.yellowHighlight,
                bold: nl.bold,
                saveAsCanned: nl.saveAsCanned,
            }));


        if (associations.length > 0) {

            associations.forEach((el: any, k: number) => {
                const associationName = el.name;

                const existingIndex = updatedAccounts.findIndex(
                    (acc) => acc.associationName === associationName
                );
                const feeList: any[] = [];
                const notes: any[] = [];

                if (existingIndex === -1) {
                    const newAccount = populateAssociation(
                        k,
                        associationName,
                        el,
                        feeList,
                        notes,
                        certificateFee,
                        baseNotes,
                        subDivisionObj
                    );


                    if (newAccount) {
                        if (k === 0) {
                            updatedAccounts[showAccount] = newAccount;
                        } else {
                            newAccount.id = null;
                            updatedAccounts.push(newAccount);
                            updatedIndices.push(updatedAccounts.length - 1);
                            updatedPropertyIds.push({ id: newAccount.accountNumber, visibility: true });
                        }
                    }
                } else {
                    updatedIndices.push(existingIndex);

                    const existingAccount = updatedAccounts[existingIndex];
                    const currentAccount = certificate.accounts[showAccount];


                    if (existingAccount.accountNumber === currentAccount.accountNumber) {
                        const isManaged = el.managementCompany !== null;
                        const contact = isManaged ? el.managementCompany?.contacts?.[0] : el.contacts?.[0] || {};

                        const email = contact?.email || '';
                        const phone = contact?.phone || '';
                        const website = contact?.website || '';
                        const address = contact?.address || {};
                        const mailingAddress = address?.mailingAddress || '';
                        const zipCode = address?.zipCode || '';
                        const city = address?.city || '';
                        const state = address?.state || '';
                        const contactName = contact?.name || '';

                        const managementCompanyName = el.managementCompany?.name || '';
                        const managementCompanyId = el.managementCompany?.id || '';
                        const thirdPartyProviderId = el.hoaThirdPartyProvider?.id || '';
                        const thirdPartyProviderName = el.hoaThirdPartyProvider?.name || '';

                        getUniqueFeeListAndNote(el, feeList, notes, certificateFee, baseNotes, setIsSavedResult);

                        const updatedAccount = {
                            ...existingAccount,
                            notes,
                            fees: feeList,
                            addAsAlias: checkBox,
                            subdivisionId: subDivisionObj.id,
                            associationId: el.id,
                            associationStatus: computeAssociationStatus(el),
                            taxDataSource: existingAccount.taxDataSource,
                        };

                        updateTotalBalance(updatedAccount, feeList);
                        updatedAccounts[showAccount].addAsAlias = checkBox;
                        updatedAccounts[showAccount].subdivisionId = subDivisionObj.id;
                        updatedAccounts[showAccount].subdivisionDTO = subDivisionObj;
                        updatedAccounts[showAccount] = PopulateHoaInfo(
                            associationName,
                            managementCompanyName,
                            managementCompanyId,
                            email,
                            phone,
                            mailingAddress,
                            zipCode,
                            city,
                            state,
                            contactName,
                            el,
                            website,
                            thirdPartyProviderId,
                            thirdPartyProviderName,
                            updatedAccount
                        );

                        setIsSavedResult(false);
                    } else {
                        const existingFee = existingAccount.fees;
                        const existingNotes = existingAccount.notes
                            .filter((nl: any) => !nl.associationNote)
                            .map((nl: any) => ({
                                comment: nl.comment,
                                associationNote: false,
                                redColor: nl.redColor,
                                yellowHighlight: nl.yellowHighlight,
                                bold: nl.bold,
                                saveAsCanned: nl.saveAsCanned
                            }));

                        const newAccount = populateAssociation(
                            k,
                            associationName,
                            el,
                            feeList,
                            notes,
                            existingFee,
                            existingNotes,
                            subDivisionObj
                        );

                   
                        if (newAccount) {
                            if (k === 0) {
                                updatedAccounts[showAccount] = newAccount;
                            } else {
                                newAccount.id = null;
                                updatedAccounts.push(newAccount);
                                updatedIndices.push(updatedAccounts.length - 1);
                                updatedPropertyIds.push({ id: newAccount.accountNumber, visibility: true });
                            }
                            
                        }
                    }
                }
            });
        } else {
            const baseAccount = { ...updatedAccounts[showAccount] };

            baseAccount.addAsAlias = checkBox;
            baseAccount.subdivisionId = subDivisionObj.id;
            baseAccount.subdivisionDTO = subDivisionObj;
            baseAccount.associationId = null;
            baseAccount.associationName = null;
            baseAccount.thirdPartyProviderId = null;
            baseAccount.thirdPartyProviderName = null;
            baseAccount.associationStatus = null;
            baseAccount.managementCompany = {
                name: null,
                managementCompanyId: null,
                email: null,
                website: null,
                phone: null,
                contactName: null,
                address: {
                    mailingAddress: null,
                    zipCode: null,
                    city: null,
                    state: null
                }
            };


            updatedAccounts[showAccount] = baseAccount;
            setIsSavedResult(false);
        }

        setCertificate((prev: any) => ({
            ...prev,
            accounts: updatedAccounts,
            propertyIds: updatedPropertyIds,
        }));

        setUpdatedAccountIndexList(updatedIndices);
        setIsSavedResult(false);
    }, [getSubdivisionByNameAndCountyResponse.data]);

    function populateAssociation(
        k: number,
        associationName: string,
        el: any,
        feeList: any[],
        notes: any[],
        certificateFee: any,
        certificateNotes: any,
        subDivisionObj: any
    ): any | null {
        const isManaged = el.managementCompany !== null;
        const contact = isManaged ? el.managementCompany?.contacts?.[0] : el.contacts?.[0] || {};

        const email = contact?.email || '';
        const phone = contact?.phone || '';
        const website = contact?.website || '';
        const address = contact?.address || {};
        const mailingAddress = address?.mailingAddress || '';
        const zipCode = address?.zipCode || '';
        const city = address?.city || '';
        const state = address?.state || '';
        const contactName = contact?.name || '';

        const managementCompanyName = el.managementCompany?.name || '';
        const managementCompanyId = el.managementCompany?.id || '';
        const thirdPartyProviderId = el.hoaThirdPartyProvider?.id || '';
        const thirdPartyProviderName = el.hoaThirdPartyProvider?.name || '';

        getUniqueFeeListAndNote(el, feeList, notes, certificateFee, certificateNotes, () => {
        });

        const currentAccount = certificate.accounts[showAccount];
        const baseAccountData = {
            propertySubdivision: currentAccount.propertySubdivision,
            stateId: currentAccount.stateId,
            countyId: currentAccount.countyId,
            zipCode: currentAccount.zipCode,
            subdivisionDTO: subDivisionObj,
            subdivisionId: subDivisionObj?.id,
            subdivisionCode: currentAccount.subdivisionCode,
            sellers: currentAccount.sellers,
            buyers: currentAccount.buyers,
            situsAddress: currentAccount.situsAddress,
            legalDescription: currentAccount.legalDescription,
            accountNumber: currentAccount.accountNumber,
            acreage: currentAccount.acreage,
            orderId: orderId,
            customerOrderNumber: customerOrderNumber,
            taxDataSource: currentAccount.taxDataSource,
        };

        if (k === 0 || currentAccount.associationName === '') {

            let updatedAccount = {
                ...currentAccount,
                ...baseAccountData,
                notes,
                fees: feeList,
                addAsAlias: checkBox,
                subdivisionDTO: subDivisionObj,
                subdivisionId: subDivisionObj?.id,
                associationId: el.id,
                associationStatus: computeAssociationStatus(el),
            };

            updateTotalBalance(updatedAccount, feeList);

            updatedAccount = PopulateHoaInfo(
                associationName,
                managementCompanyName,
                managementCompanyId,
                email,
                phone,
                mailingAddress,
                zipCode,
                city,
                state,
                contactName,
                el,
                website,
                thirdPartyProviderId,
                thirdPartyProviderName,
                updatedAccount
            );

            return updatedAccount;
        } else {
            const newAccount = {
                ...baseAccountData,
                fees: feeList,
                notes,
                productType,
                associationName: el.name,
                associationId: el.id,
                associationStatus: computeAssociationStatus(el),
                thirdPartyProviderId,
                thirdPartyProviderName,
                addAsAlias: checkBox,
                original: true,
                managementCompany: {
                    managementCompanyId,
                    name: managementCompanyName,
                    contactName,
                    address: {
                        mailingAddress,
                        zipCode,
                        city,
                        state,
                    },
                    phone,
                    email,
                    website,
                },
            };

            updateTotalBalance(newAccount, feeList);

            return newAccount;
        }
    }

    function computeAssociationStatus(el: any): string {
        const managementCompany = el.managementCompany;
        const hoaThirdPartyProvider = el.hoaThirdPartyProvider;

        if (managementCompany?.hoaThirdPartyProvider?.overrideAssociationStatus) {
            return managementCompany.hoaThirdPartyProvider.overrideAssociationStatus;
        }

        if (managementCompany?.overrideAssociationStatus) {
            return managementCompany.overrideAssociationStatus;
        }

        if (hoaThirdPartyProvider?.overrideAssociationStatus) {
            return hoaThirdPartyProvider.overrideAssociationStatus;
        }

        return el.status;
    }

    useEffect(() => {
        if (isAccountNoteDeleted) {

            setCertificate((prev: any) => {
                const updatedAccounts = [...prev.accounts];

                const account = { ...updatedAccounts[showAccount] };

                account.notes = account.notes.filter((_: any, i: any) => i !== noteIndex);
                account.taxDataSource = 'EDITOR';
                updatedAccounts[showAccount] = account;

                return {
                    ...prev,
                    accounts: updatedAccounts
                };
            });

            setIsSavedResult(false);
            setIsAccountNoteDeleted(false);
        }
    }, [isAccountNoteDeleted]);

    function deleteNote() {
        setUpdatedAccountIndexList((prev: any) => {
            if (!prev.includes(showAccount)) {
                return [...prev, showAccount]; // return a new array
            }
            return prev; // no change needed
        });
        setIsAccountNoteDeleted(true);
    }

    const accountInfo = (accounts: any, propertyIds: any) => {
        // Initialize feeList with a fallback structure if no fees are present
        let feeList = [];

        if (accounts.fees != null && accounts.fees.length > 0) {
            feeList = [...accounts.fees];
        } else {
            feeList.push({
                type: null,
                amount: null,
                currentMonth: null,
                nextMonth: null,
                periodStart: null,
                periodEnd: null,
                frequency: null,
                note: null,
                paid: null,
                associationFee: false,
            });
        }

        // Check for the presence of a management company and set the length
        const length = accounts.managementCompany != null ? Object.keys(accounts.managementCompany).length : 0;

        // Create a new managementCompany object by spreading the old one and updating the necessary properties
        const updatedManagementCompany = {
            managementCompanyId: length === 0 ? "" : accounts.managementCompany.managementCompanyId,
            name: length === 0 ? "" : accounts.managementCompany.name,
            contactName: length === 0 ? "" : accounts.managementCompany.contactName,
            address: {
                mailingAddress: length === 0 ? "" : accounts.managementCompany?.address?.mailingAddress,
                zipCode: length === 0 ? "" : accounts.managementCompany?.address?.zipCode,
                city: length === 0 ? "" : accounts.managementCompany?.address?.city,
                state: length === 0 ? "" : accounts.managementCompany?.address?.state,
            },
            phone: length === 0 ? "" : accounts.managementCompany.phone,
            email: length === 0 ? "" : accounts.managementCompany.email,
            website: length === 0 ? "" : accounts.managementCompany.website,
            id: length === 0 ? "" : accounts.managementCompany.id,
        };

        // Now create a new accounts object with the updated managementCompany
        const updatedAccounts = {
            ...accounts,
            managementCompany: updatedManagementCompany,
            fees: feeList,
            productType: productType,
        };


        setCertificate((prev: any) => {
            const updatedArray = [...prev.accounts];
            const index = updatedArray.findIndex(a => a.id === updatedAccounts.id);
            if (index !== -1) {
                updatedArray[index] = { ...updatedArray[index], ...updatedAccounts };
            } else {
                updatedArray.push(updatedAccounts); // optional, only if you want to add if not found
            }

            return {
                ...prev,
                accounts: updatedArray,
            };
        });


        propertyIds.push({ id: accounts.accountNumber, visibility: true });

        certificate.propertyIds = propertyIds;
        setCertificate((prev: any) => ({
            ...prev,
            propertyIds: [...propertyIds],
        }));
        setCertificate((prev: any) => {
            const updatedArray = [...prev.accounts];
            const index = updatedArray.findIndex(a => a.id === updatedAccounts.id);
            if (index !== -1) {
                updatedArray[index] = { ...updatedArray[index], ...updatedAccounts };
            } else {
                updatedArray.push(updatedAccounts); // optional, only if you want to add if not found
            }

            return {
                ...prev,
                accounts: updatedArray,
            };
        });
        updateTotalBalance(updatedAccounts, updatedAccounts.fees);
    }

    function handleOrderResultSubmit() {
        let properties: any[] = [];

        certificate.accounts.forEach((el: any) => {
            const isExist = properties?.find((obj) => isDuplicateAccountExist(el, obj));
            if (!isExist) {
                properties.push({
                    accountNumber: el.accountNumber,
                    subdivisionId: el.subdivisionId,
                    associationId: el.associationId
                });
            }
        });

        const similarPropertyExist = properties?.length !== certificate.propertyIds.length;

        if (similarPropertyExist) {
            setWarningMsg("Duplicate accounts found.\nPlease resolve before saving.");
            setWarningModal(true);
            return;
        }

        const uniqueIndexes = removeDuplicateAndNegativeItems(updatedAccountIndexList);

        const accountList = uniqueIndexes.map((index: any) => {
            const originalAccount = certificate.accounts[index];

            // Deep copy to avoid mutation
            const account = {
                ...originalAccount,
                fees: [...(originalAccount?.fees || [])],
                managementCompany: originalAccount.managementCompany ? { ...originalAccount.managementCompany } : null,
                subdivisionDTO: originalAccount.subdivisionDTO || null,
            };

            // Clean up fees
            account.fees = account.fees
                .map((f: any) => ({ ...f })) // clone each fee object
                .filter((fee: any) => {
                    return Object.values(fee).some(value =>
                        value !== null && value !== '' && value !== false && value !== true
                    );

                })
                .map((fee: any) => ({
                    ...fee,
                    frequency: fee.frequency || null,
                    type: fee.type || null
                }));

            if (!checkProperties(account.managementCompany)) {
                account.managementCompany = null;
            } else if (account.managementCompany?.phone) {
                account.managementCompany.phone = formatPhone(account.managementCompany.phone);
            }

            return account;
        });

        // Step 3: Submit
        setDisable(true);

        const obj = {
            hoaCertificates: accountList,
            removedAccounts: removedAccountIds,
        };

        saveHoaOrderResult({ obj, orderId })
            .unwrap()
            .then(() => {
                setDisable(false);
                setIsSavedResult(true);
                setProductStatus('SAVED');
                setShowAccount(0);
                setUpdatedAccountIndexList([]);
            })
            .catch((error: any) => {
                showToast(error['message'], "error");
                setDisable(false);
            });
    }

    const handleGeneratePdf = async () => {
        let validInfo = true;

        // Validate the certificate accounts
        for (let i = 0; i < certificate.accounts.length; i++) {
            let el = certificate.accounts[i];
            if (!el.accountNumber || !el.subdivisionId || !el.legalDescription || !el.situsAddress) {
                validInfo = false;
                setShowAccount(i);
                showToast("Cannot generate PDF without Tax ID, situs, legal, and subdivision!", "error");
                break;
            }
        }
        if (validInfo) {
            setDisable(true);

            try {
                // RTK Query mutation to generate the PDF
                const result = await generateHoaPdf({
                    orderId,
                    customerId,
                    tenant,
                    checkValidation: true,
                    cancelExistingTask: false
                }).unwrap();


                if (result['errorCode'] === 200) {
                    setActiveTaskConfirmation(false);
                    showToast("PDF created successfully!");
                    setActiveTaskConfirmation(false);

                    let customFilter = {
                        'orderId': orderId,
                        'orderFileType': [productType === "HOA_FULL" ? "HOAFull" : "HOAContact", "CADPrintout"],
                        'type': 'New'
                    }

                    checkPdfExist(customFilter);
                    dispatch(tgxApi.util.invalidateTags(["getHoaOrderResultByOrderId"]))


                    for (let i = 0; i < result['orderFileDTOList'].length; i++) {

                        const fileId = result['orderFileDTOList'][i]['id'];
                        const fileUrl = `/ajax/view-file/${fileId}`;
                        fetchPdf(fileUrl)
                            .then(blobUrl => {
                                window.open(blobUrl, '_blank');
                            })
                            .catch(error => {
                                console.error('Error fetching PDF file:', error);
                                showToast(`Failed to open file ${fileId}`, "error");
                            });
                    }

                } else {
                    if (result['message'] === "Can not generate PDF while task is incomplete!") {
                        setActiveTaskConfirmation(true);
                    } else {
                        showToast(result["message"], "error");
                    }
                    setDisable(false);
                }


            } catch (error) {
                showToast(error instanceof Error ? error.message : 'Failed to generate PDF');
            }
        }
    };

    function handleMarkAsComplete() {
        markAsCompleted({ productId: productId, productStatus: "COMPLETED" }).unwrap()
            .then(() => {
                showToast("Mark as completed successfully!", "success");
                setProductStatus("COMPLETED");
                if (setShowAccount !== null) {
                    setShowAccount(0);
                }
            })
            .catch((error: any) => {
                showToast(error['message'], "error");
            });
    }

    return (
        <>
            {!orderQuery?.data || !showForm ? <Preloader show={true} /> :
                <div>
                    <TopSection toggleAccountSection={toggleAccountSection}
                        setToggleAccountSection={setToggleAccountSection}
                        editable={editable}
                        isSavedResult={isSavedResult}
                        deliveryEmail={deliveryEmail}
                        setIsSendNotification={setIsSendNotification}
                        setShowDeliveryConfirmation={setShowDeliveryConfirmation}
                        orderData={orderQuery}
                        productStatus={productStatus}
                        handleOrderResultSubmit={handleOrderResultSubmit}
                        handleGeneratePdf={handleGeneratePdf}
                        handleMarkAsComplete={handleMarkAsComplete}
                        formType={"HOA"}
                        disable={disable}
                        setProductStatus={setProductStatus}
                        propertyHaveResult={propertyHaveResult}
                        taskList={vendorTaskList}
                        productId={productId}
                        requiresQc={requiresQc}
                        isPdfExist={isPdfExist}
                        assignTo={assignTo}
                        isValidDataForPdfGenerate={isValidDataForPdfGenerate}
                        unAcknowledged={unAcknowledged}
                        isUserManager={isUserManager}
                        setAssignedTo={setAssignTo}
                        showTeamListModal={showTeamListModal}
                        assignedTeam={assignedTeam}
                        setProductId={setProductId}
                        setShowTeamListModal={setShowTeamListModal}
                        curProduct={curProduct}
                        setAssignedTeam={setAssignedTeam}
                        setShowTeamManagerModal={setShowTeamManagerModal}
                        showTeamManagerModal={showTeamManagerModal}
                        showAccount={showAccount}
                        certificate={certificate}
                        generatePDfApi={generateHoaPdfApi.isLoading}
                        saveOrderResultApi={saveOrderResultApi.isLoading}
                        markAsCompletedApi={markAsCompletedApi.isLoading}
                    />

                    <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                        <div className="col-span-2">
                            {toggleAccountSection &&
                                <LeftBar
                                    setAddedNewAccount={setAddedNewAccount}
                                    certificate={certificate}
                                    setCertificate={setCertificate}
                                    showAccount={showAccount}
                                    setShowAccount={setShowAccount}
                                    orderId={orderId}
                                    certNoteList={certNoteList}
                                    customerNoteList={customerNoteList}
                                    setIsSavedResult={setIsSavedResult}
                                    noteType={"HOA"}
                                    showDeleteAccountConfirmation={showDeleteAccountConfirmation}
                                    setShowDeleteAccountConfirmation={setShowDeleteAccountConfirmation}
                                    similarAccountList={similarAccountList}
                                    vendorTaskList={vendorTaskList}
                                    productType={productType}
                                    setIsFetchSimilarAccountList={setIsFetchSimilarAccountList}
                                    editable={editable}
                                    qcResultList={qcResultList}
                                    unAcknowledged={unAcknowledged}
                                    similarTaxAccountListResponse={similarHoaAccountListResponse}
                                    productId={productId}
                                    orderData={orderQuery}
                                    orderResultData={orderResultData}
                                    setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                                    assignTo={assignTo}
                                    addAccountSelectedProperty={addAccountSelectedProperty}
                                    setAddAccountSelectedProperty={setAddAccountSelectedProperty}
                                    setSelectedCloneAccountList={setSelectedCloneAccountList}
                                    showAccountCloneModal={showAccountCloneModal}
                                    setShowAccountCloneModal={setShowAccountCloneModal}
                                    removedAccountIds={removedAccountIds}
                                    updatedAccountIndexList={updatedAccountIndexList}
                                    setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    setCertNotes={setCertNoteList}
                                    countyData={getAllCountyByStateAbbrApiResponse}
                                />
                            }
                        </div>

                        <div className={toggleAccountSection ? "col-span-10" : "col-span-12"}>
                            <div className="col-span-12 grid grid-cols-12 gap-3 items-center" id="pricingSection0">
                                <div className="relative col-span-12 flex items-center gap-5">
                                    <div className="w-full">
                                        <InputField
                                            className=""
                                            name="customerOrderNumber"
                                            type="text"
                                            value={orderQuery?.data?.customerOrderNumber}
                                            label="Order #"
                                            labelPosition="top"
                                            disabled
                                        />

                                    </div>

                                    <div className="w-full">
                                        <InputField
                                            name="customerOrderNumber"
                                            type="text"
                                            value={String(orderResultModifiedDate ? formatValueAsDateAndTime(orderResultModifiedDate) : "-")}
                                            label="Last Saved"
                                            labelPosition="top"
                                            disabled
                                        />
                                    </div>
                                    <div className="w-full">
                                        <InputField
                                            name="Date"
                                            type="text"
                                            value={productStatus}
                                            labelPosition="top"
                                            label="Product Status"
                                            disabled
                                        />
                                    </div>
                                    <div className="w-full">
                                        <InputField
                                            className={`rounded px-3 py-2 ${assignTo == null || assignTo === '' ? 'bg-warn-2 text-surface-0 border border-surface-0' : 'bg-surface-5 text-surface-3'}`}
                                            name="assignedTo"
                                            type="text"
                                            value={assignTo == null || assignTo === "" ? "Not assigned" : assignTo}
                                            label="Assigned To" labelPosition="top"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>


                            <RequestedInfoSection orderData={orderQuery} certificate={certificate}
                                showAccount={showAccount} isHoaEditor={true} />

                            <div
                                className="bg-text-1 rounded-[7px] shadow-md pb-2 pt-2 mt-3 col-span-12 grid grid-cols-12 w-full">
                                <div className="flex items-center justify-between col-span-12 px-2 py-2">
                                    <h5 className="text-lg font-semibold text-surface-2"
                                        title={(certificate.accounts[showAccount]?.taxDataSource !== null && certificate.accounts[showAccount]?.taxDataSource !== '') ? getUserFriendlyTaxDataSource(certificate.accounts[showAccount]?.taxDataSource) : "UNKNOWN"}>
                                        Account Information
                                        - {orderQuery?.data && orderQuery?.data?.collectorClerkLink != null && orderQuery?.data?.collectorClerkLink?.url !== null && orderQuery?.data?.collectorClerkLink?.url !== '' ?
                                            <a className={"text-highlight-4"}
                                                href={orderQuery?.data?.collectorClerkLink?.url}
                                                target={"_blank"}>{orderQuery?.data && orderQuery?.data?.properties[showAccount].propertyResult?.parsedAddress?.county}
                                            </a>
                                            :
                                            (hasPermission(["COLLINK-C"]) ?
                                                <a className={"text-highlight-4"}
                                                    onClick={() => {
                                                        localStorage.setItem("collectorObj", JSON.stringify(primaryCollector));
                                                        localStorage.setItem("collectorLinkType", 'CLERK');
                                                    }}
                                                    href={'/collector-links/create'}
                                                    target={"_blank"}>{orderQuery?.data && orderQuery?.data.county}
                                                </a> : orderQuery?.data && orderQuery?.data.county
                                            )
                                        }


                                        {(certificate.accounts[showAccount]?.taxDataSource !== null && certificate.accounts[showAccount]?.taxDataSource !== '') ? ' (Source : ' + upperCaseFirstLetter(lowerCaseAllWordsExceptFirstLetters(getUserFriendlyTaxDataSource(certificate.accounts[showAccount]?.taxDataSource))) + ')' : ''}
                                    </h5>

                                    <div className="ml-auto">
                                        <button
                                            className="text-highlight-5 focus:outline-none"
                                            onClick={toggleCollapse}
                                        >
                                            <i
                                                className={`fa fa-angle-right transition-transform duration-300 ${isCollapsed ? "rotate-90" : ""
                                                    }`}
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                </div>
                                {isCollapsed && (
                                    <div id={'accountInfo' + showAccount}
                                        className="col-span-12 py-2 px-2 bg-text-1">

                                        <div className="grid grid-cols-1 md:grid-cols-2 w-full mb-3">
                                            <div className="w-full">
                                                <PropertyInfoSection curAccount={certificate.accounts[showAccount]}
                                                    setCertificate={setCertificate}
                                                    showAccount={showAccount}
                                                    setIsSavedResult={setIsSavedResult}
                                                    stateList={stateData}
                                                    countyList={getCountyByStateIdResponse}
                                                    getCountyByStateIdApi={getCountyByStateIdApi}
                                                    setReset={setReset}
                                                    similarAccountList={similarAccountList}
                                                    setSimilarAccountList={setSimilarAccountList}
                                                    isEmptyState={isEmptyState}
                                                    isEmptyCounty={isEmptyCounty}
                                                    setIsEmptyCounty={setIsEmptyCounty}
                                                    setIsEmptyState={setIsEmptyState}
                                                    editable={editable}
                                                    setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                />
                                            </div>

                                            <HoaInfoSection curAccount={certificate.accounts[showAccount]}
                                                accounts={accounts}
                                                setAccounts={setAccounts}
                                                certificate={certificate}
                                                showAccount={showAccount}
                                                editable={editable}
                                                listCounty={getCountyByStateIdResponse?.data}
                                                setReset={setReset}
                                                checkBox={checkBox}
                                                setCheckBox={setCheckBox}
                                                sudDivisionData={getSubdivisionByNameAndCountyResponse}
                                                getSubdivisionByNameAndCountyApi={getSubdivisionByNameAndCountyApi}
                                                setIsEmptyState={setIsEmptyState}
                                                setIsEmptyCounty={setIsEmptyCounty}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                            />
                                        </div>
                                        <CommentNoteSection
                                            type={"HOA Notes"}
                                            curAccount={certificate?.accounts[showAccount]?.notes}
                                            certificate={certificate}
                                            setCertificate={setCertificate}
                                            orderId={orderId}
                                            showAccount={showAccount}
                                            setIsSavedResult={setIsSavedResult}
                                            deleteNote={deleteNote}
                                            editable={editable}
                                            setShowAdd={setShowAddCommentModal}
                                            setShowUpdate={setShowUpdateCommentModal}
                                            noteType={"accounts"}
                                            isHoaNote={true}
                                            length={certificate.accounts[showAccount]?.notes?.length + 1}
                                            setIndex={setNoteIndex}
                                            updatedAccountIndexList={updatedAccountIndexList}
                                        />


                                        {productType === 'HOA_FULL' && !['DIRECT_CONTACT', 'OUT_OF_COUNTY', 'INACTIVE'].includes(certificate.accounts[showAccount]?.associationStatus) &&
                                            <FeeListSection curAccount={certificate.accounts[showAccount]}
                                                showAccount={showAccount}
                                                certificate={certificate}
                                                setCertificate={setCertificate}
                                                accounts={accounts}
                                                setAccounts={setAccounts}
                                                isSavedResult={isSavedResult}
                                                setIsSavedResult={setIsSavedResult}
                                                editable={editable}
                                                updatedAccountIndexList={updatedAccountIndexList}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                            />}
                                    </div>

                                )}
                            </div>
                        </div>
                    </div>


                    {showDeliveryConfirmation && isArray(docList) &&
                        <PdfDeliveryConfirmationModal title={"Deliver Documents"}
                            body={"Select the documents you would like to deliver"}
                            docList={docList}
                            deliveryEmail={deliveryEmail}
                            setDeliveryEmail={setDeliveryEmail}
                            show={showDeliveryConfirmation}
                            setShow={setShowDeliveryConfirmation}
                            disable={disable}
                            setDisable={setDisable}
                            orderId={orderId}
                            productType={productType}
                            isSendNotification={isSendNotification}
                            fileType={(productType === "HOA_FULL") ? "HOAFull" : "HOAContact"}
                            isHoaOrder={true}
                            orderData={orderQuery}
                            setDocList={setDocList}
                        />
                    }

                    {showAddCommentModal &&
                        <EditorAddEditNoteForm title={"Add HOA Note"}
                            show={showAddCommentModal}
                            setShow={setShowAddCommentModal}
                            index={null}
                            certificate={certificate}
                            setCertificate={setCertificate}
                            orderId={orderId}
                            showAccount={showAccount}
                            setIsSavedResult={setIsSavedResult}
                            length={certificate.accounts[showAccount]?.notes.length + 1}
                            isHoaNote={true}
                            setUpdatedAccountIndexList={setUpdatedAccountIndexList}

                        />
                    }


                    {showUpdateCommentModal &&
                        <EditorAddEditNoteForm title={"Update  HOA Note"}
                            show={showUpdateCommentModal}
                            setShow={setShowUpdateCommentModal}
                            index={noteIndex}
                            certificate={certificate}
                            setCertificate={setCertificate}
                            orderId={orderId}
                            showAccount={showAccount}
                            setIsSavedResult={setIsSavedResult}
                            isHoaNote={true}
                            setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                        />
                    }

                    {activeTaskConfirmation ? <GenerateActivePdf show={activeTaskConfirmation}
                        setShow={setActiveTaskConfirmation} orderId={orderId}
                        customerId={customerId}
                        tenant={tenant} type={"hoa"}
                        productType={productType}
                        setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                        orderResult={orderResultData.data}
                        setIsPdfExist={setIsPdfExist} /> : <></>
                    }

                    {lockEditorPopUp &&
                        <LockConfirmationPopUp formType={"HOA"} show={lockEditorPopUp} setShow={setLockEditorPopUp}
                            orderId={orderId} setEditable={setEditable} productId={productId} />

                    }

                    {warningModal ? <ConfirmationModal title={"Alert"}
                        bodyMessage={warningMsg}
                        onSubmit={null} show={warningModal}
                        setShow={setWarningModal} isHoa={true} /> : <></>
                    }
                </div>
            }
        </>
    )
}
export default HoaDetailTabSection


